<div class="auth-page">
    <div class="auth-card" *ngIf="!validKey">
        <div class="auth-brand">
            <mat-icon class="auth-status-icon">schedule</mat-icon>
        </div>

        <h1 class="auth-title">Link scaduto</h1>
        <p class="auth-subtitle">Il link che ti ha portato a questa pagina è scaduto.</p>

        <a routerLink="/" class="fo-btn fo-btn--primary fo-btn--block auth-submit">Ritorna alla Home.</a>

        <p class="auth-note">Grazie.</p>
    </div>
</div>
